import DeleteButton from 'CMFW/button/DeleteButton';
import SaveButton from 'CMFW/button/SaveButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Flag from 'CMFW/input/Flag';
import TextInput from 'CMFW/input/TextInput';
import { ContainerLeft, EditorGapGreedy, EditorRow } from 'components/common/styles';
import React, { useCallback, useContext } from 'react';
import styled from 'styled-components';
import { LessonSelect } from '../../../components/selects/LessonSelect';
import IllustrationPNG from '../../compounds/IllustrationPNG';
import IllustrationModel from '../../../models/IllustrationModel';
import { IIllustration } from '../../../types/illustration';
import BookModel from '../../../models/BookModel';
import { IRefIds } from '../../../constants/refs';

const BookEdit: React.FC = () => {
  const module = useContext(ModuleContext) as BookModel;
  const illustrationModel = new IllustrationModel();

  const illustration: IIllustration | undefined = module.getItemValue('illustration');
  const bookId: number = module.getItemValue('id') ?? 0;

  const handleUpload = useCallback(
    async (file: File) => {
      return await illustrationModel.uploadPNGByRef(IRefIds.book, bookId, file);
    },
    [bookId, illustrationModel]
  );

  const handleDelete = useCallback(async () => {
    await illustrationModel.deletePNGByRef(IRefIds.book, bookId);
  }, [bookId, illustrationModel]);

  const handleReload = useCallback(() => {
    module.reloadItem();
  }, [module]);

  return (
    <ContainerLeftStyled>
      <EditorRow>
        <Flag />
        <LessonSelect isLinked />
      </EditorRow>
      <EditorRow>
        <TextInput keyName={'title'} label={'Title'} />
      </EditorRow>
      <EditorRow>
        <TextInput keyName={'author'} label={'By'} />
        <SaveButton />
      </EditorRow>
      <EditorRow>
        {illustration && (
          <IllustrationPNG
            illustration={illustration}
            onUpload={handleUpload}
            onDelete={handleDelete}
            onReload={handleReload}
            showStages={false}
            uploadTitle="Upload Book Cover"
            uploadDescription="Upload a PNG image (500x380 pixels) for this book."
          />
        )}
      </EditorRow>
      <EditorGapGreedy />
      <DeleteButton />
    </ContainerLeftStyled>
  );
};

export default BookEdit;

export const ContainerLeftStyled = styled(ContainerLeft)`
  justify-content: space-between;
`;
